// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CloudFilledSvg from "@fishx/icons-svg/es/asn/CloudFilled";
import FishxIcon from '../components/FishxIcon';

var CloudFilled = function CloudFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CloudFilledSvg
  }));
};

CloudFilled.displayName = 'CloudFilled';
export default React.forwardRef(CloudFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CloudFilled.js
// module id = 2245
// module chunks = 0